
// Creates a validator that requires the property only if 'other' is not defined
// Example:
// {
//   name: requiredIfOtherIsUndefined('otherName'),
//   otherName: PropTypes.string
// }
// The above code would require 'name' if otherName = undefined else it would be optional
//
export const requiredIfOtherIsUndefined = (other, otherType = null) => {
  return (props, propName) => {
    const otherTypeCheck = otherType != null ? typeof (props[propName]) !== other : false;
    // only required if group is not defined, since path does not make any sense when group is defined.
    if (props[other] === undefined && (props[propName] === undefined || (typeof (props[propName]) !== 'string' && otherTypeCheck))) {
      return new Error('Please provide a \'' + propName + '\' if \'' + other + '\' is undefined');
    }
  };
};
